// View.js
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return IRCanvas;
    }
});
const _konva = /*#__PURE__*/ _interop_require_default(require("konva"));
const _debounce = /*#__PURE__*/ _interop_require_default(require("../lib/utils/debounce.js"));
const _imageToCanvas = require("../lib/Image/imageToCanvas.js");
const _enums = require("../lib/enums");
const _Containers = require("./Containers");
const _KonvaShapes = /*#__PURE__*/ _interop_require_default(require("./KonvaShapes"));
const _Cursor = /*#__PURE__*/ _interop_require_default(require("./Cursor"));
const _ContextMenu = /*#__PURE__*/ _interop_require_default(require("./ContextMenu"));
const _RotationGroup = /*#__PURE__*/ _interop_require_default(require("./Group/RotationGroup.js"));
const _KonvaTransformer = require("./Containers/KonvaTransformer.js");
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
class IRCanvas {
    // LISTENERS ====================================================================
    findShapeById(id) {
        if (!id) return;
        return this.groupShapes.find((node)=>node.attrs.id === id)[0];
    }
    setShapeFocusById(id, nextBool = false) {
        if (!id) return;
        const foundShape = this.findShapeById(id);
        if (foundShape) {
            foundShape.setFocus(nextBool);
            return foundShape;
        }
    }
    updateTransformer(shapes = []) {
        const nodes = Array.isArray(shapes) ? shapes : [
            shapes
        ];
        // do not attach transformer to circles
        if (shapes.getClassName() === _enums.KonvaShapes.CIRCLE) {
            this.transformer.enabledAnchors([]);
        } else {
            this.transformer.enabledAnchors(Object.values(_KonvaTransformer.anchorEnum));
        }
        this.transformer.nodes(nodes);
        this.layerShapes.batchDraw();
    }
    moveShapeToTop(node) {
        try {
            const numberOfShapes = this.groupShapes.getChildren().length;
            const parent = node.getParent();
            parent.zIndex(numberOfShapes - 1);
        } catch (e) {
            console.warn("Error in moving shape to top -- ", e);
        }
    }
    setShapeLayerVisible(visible = true) {
        if (this.layerShapes) {
            this.layerShapes.visible(visible);
        }
    }
    createImageFromBuffer(buffer, config = {}) {
        if (!buffer) return;
        const { name = "image" } = config;
        const canvasImage = (0, _imageToCanvas.imageDataToCanvas)(buffer);
        const prevImage = this.groupImages.find(`.${name}`)[0];
        if (prevImage) {
            prevImage.destroy();
        }
        const konvaImage = (0, _Containers.createKonvaImage)(_object_spread({
            name,
            image: canvasImage
        }, config));
        if (konvaImage && this.groupImages) {
            this.groupImages.add(konvaImage);
            this.stage.batchDraw();
            return konvaImage;
        }
    }
    setDrawingShape(item) {
        this.Drawing["activeShape"] = item;
        if (item) {
            this.Drawing.enabled = true;
        } else {
            this.Drawing.enabled = false;
        }
    }
    constructor(props = {}){
        _define_property(this, "getCursorPosition", ()=>{
            // get the position on canvas
            return this.stage.getPointerPosition();
        });
        _define_property(this, "invertTransform", (point = {}, useAbsolute = true)=>{
            // get the position on canvas
            let transform;
            if (useAbsolute) {
                transform = this.imageVL.getAbsoluteTransform().copy();
            } else {
                transform = this.imageVL.getTransform().copy();
            }
            transform.invert();
            return transform.point(point);
        });
        _define_property(this, "handleShapeUpdate", (shape = {}, useAbsolute = true)=>{
            // before updating marker, convert absolute position to relative position
            let { type, points = [] } = shape;
            points = points.map((point)=>this.invertTransform(point, useAbsolute));
            // skip update if update is outside of IR image
            // if (hasBoundaryCrossing(_points)) return;
            // returns the id of the created object for the draw layer to track
            const _id = this.onShapeUpdate(_object_spread_props(_object_spread({}, shape), {
                type,
                points
            }), "update");
            return _id;
        });
        _define_property(this, "saveAsImage", async ()=>{
            if (!this.stage) return Promise.resolve();
            let success = true;
            const tempContainer = document.createElement("div");
            tempContainer.style.display = "none";
            document.body.appendChild(tempContainer);
            const newStage = new _konva.default.Stage({
                container: tempContainer,
                width: this.stageWidth,
                height: this.stageHeight
            });
            // Filter out cursor layer
            const layersToClone = this.stage.children.filter((layer)=>layer.attrs.name !== "layer-cursor");
            layersToClone.forEach((layer)=>{
                try {
                    const clonedLayer = layer.clone();
                    clonedLayer.listening(false);
                    clonedLayer.off("draw");
                    newStage.add(clonedLayer);
                } catch (error) {
                    success = false;
                    console.error(`Failed to copy layer: ${layer === null || layer === void 0 ? void 0 : layer.name()} -- `, error);
                }
            });
            if (success) {
                newStage.batchDraw();
                const image = await new Promise((resolve)=>{
                    newStage.toImage({
                        callback: (img)=>resolve(img),
                        mimeType: "image/jpeg",
                        quality: 1
                    });
                });
                this.onSave(image);
            }
            newStage.destroy();
            document.body.removeChild(tempContainer);
        });
        _define_property(this, "updateDrawingPoints", (eventType = "mouseclick")=>{
            let { id, points, activeShape } = this.Drawing;
            if (!activeShape || eventType === "mousemove" && points.length < 1) return [];
            // drawing config -->
            const [className, shapeType] = activeShape.split("-");
            const nextPoint = this.getCursorPosition();
            // special conditions -->
            const isCircleShape = shapeType === _enums.KonvaShapes.CIRCLE;
            const isTextShape = shapeType === _enums.KonvaShapes.TEXT;
            const isSecondClick = eventType === "mouseclick" && points.length === 1;
            const _draw = ()=>{
                // start or continue drawing -->
                this.setIsDrawingActive(true);
                this.Drawing["id"] = this.handleShapeUpdate({
                    className,
                    id,
                    type: shapeType,
                    points: [
                        ...points,
                        nextPoint
                    ]
                });
                if (this.Drawing.id && !this.Drawing.focusShape) {
                    // fire shape drawstart event
                    this.Drawing.focusShape = this.setShapeFocusById(this.Drawing.id, true);
                }
            };
            const _drawend = ()=>{
                // end drawing -->
                this.setIsDrawingActive(false);
                // fire shape drawend event
                this.setShapeFocusById(id, false);
                this.Drawing = {
                    enabled: this.Drawing.enabled,
                    active: false,
                    id: "",
                    points: [],
                    activeShape: isTextShape ? "" : activeShape,
                    focusShape: null
                };
            };
            if (isCircleShape || Object.values(_enums.KonvaShapes).includes(shapeType) && points.length === 1) {
                _draw();
            }
            if (isCircleShape || isSecondClick) {
                _drawend();
                return;
            }
            if (eventType === "mouseclick") {
                this.Drawing["points"] = [
                    ...points,
                    nextPoint
                ];
            } else {
                this.Drawing["points"] = points;
            }
        });
        _define_property(this, "handleMouseDown", (e)=>{
            const clickedOn = e.target.className;
            const clickedOnEmpty = clickedOn === "Image" || !clickedOn;
            // close the context menu
            this.setContextMenu({
                enabled: false
            });
            // when mouse click has been detected
            if (!clickedOnEmpty) {
                // clicked on shape
                e.cancelBubble = true;
                const node = e.target;
                this.updateTransformer(node);
                this.moveShapeToTop(node);
            }
            if (!this.Drawing.active && clickedOnEmpty) {
                // deselect when clicked anywhere not a marker
                // destroy transformer
                this.transformer.nodes([]);
            }
            if (this.Drawing.enabled && clickedOnEmpty) {
                const isLeftClick = e.evt.button === 0;
                if (isLeftClick) {
                    this.updateDrawingPoints("mouseclick");
                }
            }
        });
        _define_property(this, "handleMouseEvent", (e)=>{
            const { target, type } = e;
            const targetClass = target.className;
            if (targetClass === "Image" && type === "mousemove") {
                // mouse is moving over image -->
                const canvasPosition = this.getCursorPosition();
                const relativePosition = this.invertTransform(canvasPosition);
                var _this_onCursorUpdate;
                this.setCursor({
                    position: canvasPosition,
                    enabled: true,
                    style: "crosshair",
                    text: (_this_onCursorUpdate = this.onCursorUpdate(relativePosition)) !== null && _this_onCursorUpdate !== void 0 ? _this_onCursorUpdate : ""
                });
                if (this.Drawing.enabled) {
                    this.updateDrawingPoints("mousemove");
                }
            } else if (targetClass === "Image" && type === "mouseleave") {
                // mouse has moved away from image -->
                this.setCursor({
                    enabled: true,
                    style: "default",
                    text: ""
                });
            } else if (targetClass !== "Image" && type === "mouseenter") {
                // mouse has entered a shape -->
                this.setCursor({
                    style: "pointer"
                });
            }
        });
        _define_property(this, "handleKeyDown", (e)=>{
            // 46 maps to the Delete key
            // 8 maps to the Backspace key
            const pressedDelete = e.keyCode === 46 || e.keyCode === 8 || e.key === "Delete" || e.key === "Backspace";
            // delete the selected marker
            if (pressedDelete) {
                const activeSelection = this.transformer.nodes()[0];
                if (activeSelection) {
                    const selectedShape = activeSelection.getParent().shape;
                    this.onShapeUpdate(selectedShape, "delete");
                    this.transformer.nodes([]);
                }
            }
        });
        _define_property(this, "handleContextMenu", (e, type, item)=>{
            switch(type){
                case "menu-select":
                    this.setDrawingShape(item);
                    this.setContextMenu({
                        enabled: false
                    });
                    break;
                default:
                    e.evt.preventDefault();
                    this.setContextMenu({
                        enabled: true,
                        position: this.getCursorPosition()
                    });
                    break;
            }
        });
        _define_property(this, "handleDrawComplete", ({ debounce = true })=>{
            if (this.layerShapes.listening() === false) return;
            if (this.Drawing.active === false || this.contextMenu.visible()) {
                if (debounce) {
                    this.debounceSaveImage.call();
                } else {
                    this.saveAsImage();
                }
            }
        });
        _define_property(this, "initializeStage", ()=>{
            this.debounceSaveImage = new _debounce.default(this.saveAsImage, 50);
            this.stage = (0, _Containers.createKonvaStage)({
                container: this.container,
                width: this.stageWidth,
                height: this.stageHeight,
                interactive: this.interactive,
                visible: this.visible,
                onContextMenu: this.handleContextMenu
            });
            this.layerImages = (0, _Containers.createKonvaLayer)({
                name: "layer-images",
                visible: this.isMarkerLayerVisible,
                onDraw: ()=>this.handleDrawComplete({
                        debounce: true
                    })
            });
            this.layerShapes = (0, _Containers.createKonvaLayer)({
                name: "layer-shapes",
                visible: this.isMarkerLayerVisible,
                onDraw: ()=>this.handleDrawComplete({
                        debounce: true
                    })
            });
            this.layerCursor = (0, _Containers.createKonvaLayer)({
                name: "layer-cursor"
            });
            // IMAGES GROUP -->
            this.groupImages = new _RotationGroup.default({
                center: {
                    x: this.stageWidth / 2,
                    y: this.stageHeight / 2
                }
            });
            this.groupShapes = new _RotationGroup.default({
                center: {
                    x: this.stageWidth / 2,
                    y: this.stageHeight / 2
                }
            });
            this.transformer = (0, _Containers.createKonvaTransformer)({
                rotateEnabled: false,
                ignoreStroke: true,
                keepRatio: false,
                flipEnabled: false
            });
            this.layerImages.add(this.groupImages);
            this.layerShapes.add(this.groupShapes);
            this.layerShapes.add(this.transformer);
            // CURSOR LAYER -->
            this.cursor = (0, _Cursor.default)();
            this.contextMenu = (0, _ContextMenu.default)({
                onSelect: (item)=>this.handleContextMenu(null, "menu-select", item)
            });
            this.layerCursor.add(this.cursor);
            this.layerCursor.add(this.contextMenu);
            // ADD LAYERS TO STAGE -->
            this.stage.add(this.layerImages);
            this.stage.add(this.layerShapes);
            this.stage.add(this.layerCursor);
        });
        _define_property(this, "destroyStage", ()=>{
            this.stage.destroy();
        });
        _define_property(this, "setInteractive", (interactive = true)=>{
            if (this.stage) {
                this.stage.listening(interactive ? true : false);
            }
        });
        _define_property(this, "setHidden", (hidden = false)=>{
            if (this.stage) {
                this.stage.visible(hidden ? false : true);
            }
        });
        _define_property(this, "setCursor", (config = {})=>{
            const { style, position, text } = config;
            if (!this.stage || !this.cursor) return;
            if (position) {
                this.cursor.position(position);
            }
            if (text || text === "") {
                this.cursor.text(text);
            }
            if (style) {
                this.stage.container().style.cursor = style;
            }
        });
        _define_property(this, "setContextMenu", (menuConfig = {})=>{
            const { enabled = false, position = {
                x: 0,
                y: 0
            } } = menuConfig;
            if (this.stage) {
                this.contextMenu.position(position);
                this.contextMenu.visible(enabled);
            }
        });
        _define_property(this, "setRotation", (theta = 0)=>{
            if (!this.groupImages || !this.groupShapes) return;
            this.rotation = theta;
            this.groupImages.rotateBy(theta);
            this.groupShapes.rotateBy(theta);
            const nodes = this.groupShapes.find("Group");
            nodes.forEach((node)=>{
                if (node.constructor.name !== "RotationGroup") {
                    // set internal shape rotation
                    if (node.setShapeRotation) {
                        node.setShapeRotation(this.rotation);
                    }
                }
                if (node.constructor.name === "RotationGroup") {
                    // set parent group rotation (counter rotated)
                    node.rotation(-this.rotation);
                }
            });
        });
        _define_property(this, "updateImageIR", (ir, vl)=>{
            if (!ir || !vl) return;
            const config = {
                name: "image-ir",
                x: this.stageWidth * (1 - ir.width / vl.width) / 2,
                y: this.stageHeight * (1 - ir.height / vl.height) / 2,
                width: this.stageWidth * (ir.width / vl.width),
                height: this.stageHeight * (ir.height / vl.height),
                onMouseMove: this.handleMouseEvent,
                onMouseLeave: this.handleMouseEvent,
                onMouseDown: this.handleMouseDown
            };
            const konvaImage = this.createImageFromBuffer(ir, config);
            if (konvaImage) {
                konvaImage.moveUp();
            }
        });
        _define_property(this, "updateImageVL", (vl)=>{
            if (!vl) return;
            const config = {
                name: "image-vl"
            };
            const konvaImage = this.createImageFromBuffer(vl, config);
            if (konvaImage) {
                konvaImage.moveDown();
                this.imageVL = konvaImage;
            }
        });
        _define_property(this, "updateImagePreview", (preview, ir, vl)=>{
            if (!preview) return;
            const config = {
                name: "image-preview",
                height: this.stageHeight,
                width: this.stageWidth,
                visible: !(ir && vl)
            };
            const konvaImage = this.createImageFromBuffer(preview, config);
            if (konvaImage) {
                konvaImage.zIndex(0);
            }
        });
        _define_property(this, "setShapes", (shapes = [])=>{
            // Clear the group before adding new shapes
            if (!this.groupShapes || !this.stage) return;
            const shapeIds = shapes.map((shape)=>shape.id);
            // Remove shapes that are not present in the updated shapes list
            this.groupShapes.getChildren().forEach((shape)=>{
                if (!shapeIds.includes(shape.attrs.id)) {
                    shape.destroy();
                }
            });
            // Add or update shapes
            shapes.forEach((shapeData)=>{
                const existingShape = this.findShapeById(shapeData.id);
                if (existingShape) {
                    // Update existing shape
                    existingShape.update(shapeData);
                } else {
                    // Add new shape
                    const node = (0, _KonvaShapes.default)({
                        shape: shapeData,
                        rotation: this.rotation,
                        onMouseDown: this.handleMouseDown,
                        onShapeTransform: (attrs)=>this.handleShapeUpdate(attrs, false),
                        onMouseEnter: this.handleMouseEvent
                    });
                    if (node) {
                        this.groupShapes.add(node);
                    }
                }
            });
            // force init of rotation on shapes layer
            this.setRotation(this.rotation);
            this.transformer.forceUpdate();
        });
        _define_property(this, "setIsDrawingActive", (nextBool = false)=>{
            this.Drawing.active = nextBool;
            this.layerShapes.listening(!nextBool);
        });
        // configuration -->
        const { // config -->
        container = "container", width = 640, height = 480, rotation = 0, isMarkerLayerVisible = true, interactive = true, visible = true, // event callbacks -->
        onShapeUpdate = ()=>{}, onCursorUpdate = ()=>{}, onSave = ()=>{} } = props;
        // config -->
        this.container = container;
        this.stageWidth = width;
        this.stageHeight = height;
        this.rotation = rotation;
        this.isMarkerLayerVisible = isMarkerLayerVisible;
        this.interactive = interactive;
        this.visible = visible;
        // callbacks -->
        this.onShapeUpdate = onShapeUpdate;
        this.onCursorUpdate = onCursorUpdate;
        this.onSave = onSave;
        this.debounceSaveImage = null;
        // konva -->
        this.stage = null;
        this.layerImages = null;
        this.layerShapes = null;
        this.layerCursor = null;
        this.groupImages = null;
        this.groupShapes = null;
        this.transformer = null;
        this.cursor = null;
        this.contextMenu = null;
        this.imageVL = null;
        // irviewer -->
        this.Drawing = {
            id: "",
            points: [],
            activeShape: "",
            enabled: false,
            active: false,
            focusShape: null
        };
    }
}
